/// <amd-module name="Test/TestPlansHubRefresh/Pivots/AuthorPivot/Component/GridViewConnectedComponent" />
import * as React from "react";
import { connect } from "react-redux";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentContext, VssComponent, IVssComponentProperties, IVssLayoutManager } from "VSS/Platform/Layout";
import { ILegacyComponentProperties, LegacyComponent } from "VSS/Legacy/Legacy";
import { GridOptions } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorContracts";

export interface IGridViewComponentProps extends IVssComponentProperties {}

/**
 * GridViewComponent: Renders the initial Grid view when define tab is loaded.
 */
export class GridViewComponent extends VssComponent<IGridViewComponentProps, IVssComponentContext> {
    private _context: IVssPageContext;

    constructor(props: IGridViewComponentProps, context?: IVssComponentContext) {
        super(props, context);
        this._context = context!.pageContext;
    }

    public componentDidMount() {
        const layoutManager = this._context.getService<IVssLayoutManager>("IVssLayoutManager");
        const gridViewProxyComponentProps = {
            gridOption: GridOptions.CreateGrid
        }
        layoutManager.renderCallout((onDismiss: any) => {
            const properties: ILegacyComponentProperties = {
                modules: ["TestManagement/Scripts/Shared/GridViewProxyComponent"],
                wrappedType: "grid-view-proxy-component",
                wrappedProps: gridViewProxyComponentProps
            };
            return React.createElement(LegacyComponent, properties);
        });
    }
    
    public render(): JSX.Element {
        // div with class name "testplans-hub-refresh-grid-area" act as the parent div for the grid view rendered above using layoutManager  
        return (
            <div className="testplans-hub-refresh-author-pivot-for-grid" >
                <hr className="testplans-hub-refresh-hr" />
                <div className="hub-pivot-toolbar" />
                <hr className="testplans-hub-refresh-hr" />
                <div className="testplans-hub-refresh-grid-area" />
            </div>
        )
    }
}

export const GridViewConnectedComponent = connect(
    null,
    null
)(GridViewComponent);

VssComponent.register("gridView", GridViewConnectedComponent as ((props: IGridViewComponentProps) => JSX.Element));